import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const buildEntries = (data) => {
  const out = [];
  const obj = data || {};
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    out.push([keys[i], obj[keys[i]]]);
  }
  out.sort((a, b) => b[1] - a[1]);
  return out;
};

export const FrequencyCard = ({ title, data }) => {
  const entries = buildEntries(data);
  const max = entries.length ? entries[0][1] : 0;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {entries.length === 0 ? (
          <p className="text-sm text-gray-500">No data.</p>
        ) : (
          <div>
            {entries.map((row) => {
              const label = row[0];
              const count = row[1];
              const width = max > 0 ? Math.round((count / max) * 100) : 0;
              return (
                <div key={label} className="mb-2">
                  <div className="flex justify-between text-xs text-gray-700 mb-1">
                    <span className="font-medium">{label}</span>
                    <span className="text-gray-500">{count}</span>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-[#07743F] to-[#72BF44]"
                      style={{ width: `${width}%` }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default FrequencyCard;
